import { RequestSender, useBackendApi } from 'nekst-api';

export default function usePlansApi(): RequestSender {
  return useBackendApi();
}
